/*
 * Authors: mariushirjanu
 * Created: 05/04/2017
 * Upgraded: 06/12/2022
 */

import * as _ from 'underscore';
import { Component, Input, OnChanges } from '@angular/core';
import { IQuestion } from '../../../type_definitions/datatypes';
import { util } from '../util';

@Component({
  selector: 'survey-questions',
  template: `
    <div>
      <h2 *ngIf="title && surveyQuestions.length">{{title}}</h2>
      <div class="question" *ngFor="let question of surveyQuestions; trackByProp: 'question'">
        <h3>{{question.question}}</h3>
        <p>{{question.answer}}</p>
      </div>
    </div>
  `
})
export class SurveyQuestionsComponent implements OnChanges {
  @Input() public title:string;
  @Input() public questions:IQuestion[];
  @Input() public onlyAnswered:boolean;
  public surveyQuestions:IQuestion[];

  constructor() {
    /***/
  }

  public ngOnChanges():void {
    this.filterQuestions();
  }

  private filterQuestions():void {
    if (this.onlyAnswered) {
      this.surveyQuestions = _.filter(this.questions, (question:IQuestion) => !util.isNullOrUndefinedOrEmpty(question.answer));
    } else {
      this.surveyQuestions = this.questions;
    }
  }
}